import Vue from 'vue'
import Vuex from 'vuex'

import mutations from '@/store/mutations'

import App from './modules/app'
import Directory from './modules/directory'
import Statement from './modules/statement'
import StatementManual from './modules/statementManual'
import InspectionManual from './modules/inspectionManual'
import Profile from './modules/profile'
import Client from './modules/client'
import Media from './modules/media'
import Branches from './modules/branches'
import Inspection from './modules/inspection'
import CertificationAgency from './modules/certificationAgency'
import AccountVL from './modules/accountVL'
import UserVL from './modules/userVL'
import Contract from './modules/contract'
import Search from './modules/search'
import TechSupport from './modules/techSupport'
import Notification from './modules/notification'

// Measurements
import MeasurementStands from './modules/Measurements/Stands'
import HistoryBrakeMeasurements from './modules/Measurements/History/Brake'
import Measurement from './modules/Measurements/Measurement'
import MeasurementNoise from './modules/Measurements/NoiseTest'
import MeasurementLightTransmission from './modules/Measurements/LightTransmission'
import MeasurementSmoke from './modules/Measurements/Smoke'
import MeasurementGas from './modules/Measurements/Gas'
import MeasurementBrake from './modules/Measurements/Brake'

// Technical Control
import StatementTechnicalControl from './modules/technicalControl/statement'
import InspectionTechnicalControl from './modules/technicalControl/inspection'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app: App,
    directory: Directory,
    statement: Statement,
    statementManual: StatementManual,
    inspectionManual: InspectionManual,
    profile: Profile,
    client: Client,
    media: Media,
    branches: Branches,
    inspection: Inspection,
    stands: MeasurementStands,
    historyBrakeMeasurements: HistoryBrakeMeasurements,
    measurementNoise: MeasurementNoise,
    MeasurementLightTransmission: MeasurementLightTransmission,
    MeasurementSmoke: MeasurementSmoke,
    MeasurementGas: MeasurementGas,
    measurementBrake: MeasurementBrake,
    measurement: Measurement,
    statementTechnicalControl: StatementTechnicalControl,
    inspectionTechnicalControl: InspectionTechnicalControl,
    certificationAgency: CertificationAgency,
    accountVL: AccountVL,
    user: UserVL,
    contract: Contract,
    search: Search,
    techSupport: TechSupport,
    notification: Notification
  },
  mutations

})

export default store
